import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { ListItemIcon, Typography } from '@material-ui/core';
import getIcon from './getIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { display: 'flex' },
    paper: { marginRight: theme.spacing(2) },
  }),
);
const iconSize = "small"
const alertFilterIcon = <ListItemIcon>{getIcon("ALERT", "ACTIVE", iconSize)}{getIcon("ALERT", "ACKNOWLEDGED", iconSize)}</ListItemIcon>;
const notificationFilterIcon = <ListItemIcon>{getIcon("NOTIFICATION", "ACTIVE", iconSize)}{getIcon("NOTIFICATION", "ACKNOWLEDGED", iconSize)}</ListItemIcon>;
const infoFilterIcon = <ListItemIcon>{getIcon("INFO", "ACKNOWLEDGED", iconSize)}</ListItemIcon>;
interface TypeFilterMenuProps {
  onChangeListener: (value: any) => void;
}

export default function TypeFilterMenu(props: TypeFilterMenuProps) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = (event: any) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) return;
    if (typeof event === 'string') props.onChangeListener(event);
    setOpen(false);
  };

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) anchorRef.current!.focus();
    prevOpen.current = open;
  }, [open]);

  return <div className={classes.root}>
    <Button
      ref={anchorRef}
      aria-controls={open ? 'menu-list-grow' : undefined}
      aria-haspopup="true"
      onClick={handleToggle}
      variant="outlined"
    >
      Filter by type
    </Button>
    <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
        >
          <Paper>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                <MenuItem onClick={() => handleClose("")}><ListItemIcon />All</MenuItem>
                <MenuItem onClick={() => handleClose("ALERT")}>{alertFilterIcon} Alert</MenuItem>
                <MenuItem onClick={() => handleClose("NOTIFICATION")}>
                  {notificationFilterIcon} Notification
                </MenuItem>
                <MenuItem onClick={() => handleClose("INFO")}>{infoFilterIcon} Info</MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
    <Typography></Typography>
  </div>;
}
